var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindyLm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181 108C202.539 108 220 90.5391 220 69C220 47.4609 202.539 30 181 30C159.461 30 142 47.4609 142 69C142 71.7614 144.239 74 147 74C149.761 74 152 71.7614 152 69C152 52.9837 164.984 40 181 40C197.016 40 210 52.9837 210 69C210 85.0163 197.016 98 181 98C180.658 98 180.323 98.0344 180 98.1C179.677 98.0344 179.342 98 179 98H25C22.2386 98 20 100.239 20 103C20 105.761 22.2386 108 25 108H179C179.342 108 179.677 107.966 180 107.9C180.323 107.966 180.658 108 181 108ZM20 123C20 125.761 22.2386 128 25 128H142C154.703 128 165 138.297 165 151C165 163.703 154.703 174 142 174C139.239 174 137 176.239 137 179C137 181.761 139.239 184 142 184C160.225 184 175 169.225 175 151C175 134.423 162.777 120.701 146.852 118.354C146.279 118.126 145.654 118 145 118H142H25C22.2386 118 20 120.239 20 123ZM25 138C22.2386 138 20 140.239 20 143C20 145.761 22.2386 148 25 148H116C118.761 148 121 145.761 121 143C121 140.239 118.761 138 116 138H25Z",
    fill: "#A3B6C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindyLm);
export default __webpack_public_path__ + "static/media/windy-lm.5c9f44fd11ce49288fd85614ae6bf058.svg";
export { ForwardRef as ReactComponent };